'use client';

import React, { useEffect, useState } from 'react';

import Image from 'next/image';

import { motion } from 'framer-motion';

import { MarketingRegisterMethods } from '@/features/v2/auth/register/MarketingRegisterMethods';

import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from '@/components/ui/accordion';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

import {
  // _100o100,
  // claimWeb,
  IconBall,
  IconDice,
  IconTrash,
} from '@/public/img/marketing/promotions';

import '../Styles.css';

const diceVariants = {
  initial: { rotate: 0 },
  animate: {
    rotate: [0, 360, 720, 1080, 1440, 1800, 1440, 1080, 720, 360, 0],
    transition: {
      duration: 9,
      ease: [0.83, 0, 0.17, 1],
      repeat: Infinity,
      repeatType: 'loop' as const,
    },
  },
};

const footballVariants = {
  initial: { y: 0 },
  animate: {
    y: [0, -7, 10],
    transition: {
      duration: 1,
      repeat: Infinity,
      repeatType: 'loop' as const,
    },
  },
};
const WebWelcomeBonus = () => {
  const [timeLeft, setTimeLeft] = useState(6 * 60);
  const [welcomeBonus, setWelcomeBonus] = useState<string | null>(null);

  useEffect(() => {
    if (timeLeft > 0) {
      const interval = setInterval(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
      return () => {
        return clearInterval(interval);
      };
    }
    return () => {
      return undefined;
    };
  }, [timeLeft]);

  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return (
    <div className="min-h-screen bg-background md:h-screen pt-5 md:pt-5 relative">

      <div className="absolute inset-0 z-0 md:hidden">
        <Image
          src="https://secrzaapg5nnoosz.public.blob.vercel-storage.com/powerbet/ui/marketing/register-defaul.webp"
          alt="Background"
          fill
          className="object-cover"
          priority
          unoptimized
        />
      </div>

      <div className="absolute inset-0 z-1 md:hidden bg-background opacity-90" />

      <div className="hidden md:block absolute right-0 top-0 bottom-0 z-0 w-1/2">
        <Image
          src="https://secrzaapg5nnoosz.public.blob.vercel-storage.com/powerbet/ui/marketing/register-defaul.webp"
          alt="Welcome bonus"
          fill
          className="object-cover"
          unoptimized
        />
      </div>

      <div
        className="hidden md:block"
        style={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: '50%',
          width: '50%',
          background: 'linear-gradient(to right, hsl(267, 32%, 11%), transparent)',
          pointerEvents: 'none',
          zIndex: 1,
        }}
      />

      <div className="relative z-10 flex flex-col px-4 md:flex-row items-start gap-8 h-full">
        <div className="flex-1 max-w-2xl w-full md:pl-8">
          <div className="row-span-1 md:row-span-2 mb-2">
            <div className="flex items-center justify-center gap-4">
              <div className="bg-sivarbet-secondary-bg rounded-sm p-2 h-[60px] w-[60px] text-sivarbet-secondary font-bold text-2xl">
                <p className="text-center text-sivarbet-secondary font-bold text-2xl">
                  {minutes}
                </p>
                <p className="text-center text-sivarbet-text text-[9px] mt-[-10px]">
                  MIN
                </p>
              </div>
              <div className="bg-sivarbet-secondary-bg rounded-sm p-2 h-[60px] w-[60px] text-sivarbet-secondary font-bold text-2xl">
                <p className="text-center text-sivarbet-secondary font-bold text-2xl">
                  {seconds}
                </p>
                <p className="text-center text-sivarbet-text text-[9px] mt-[-10px]">
                  SEC
                </p>
              </div>
            </div>
          </div>
          <div className="w-full">
            <Accordion type="single" collapsible className="w-full mb-4" defaultValue="item-1">
              <AccordionItem value="item-1">
                <AccordionTrigger className="text-sivarbet-text font-medium">
                  ¿Quieres escoger un regalo?
                </AccordionTrigger>
                <AccordionContent>
                  <RadioGroup value={welcomeBonus || ''} onValueChange={setWelcomeBonus} className="space-y-2">
                    <div className="flex items-center justify-between p-4 rounded-lg border border-sivarbet-border bg-sivarbet-background h-[60px]">
                      <div className="flex items-center space-x-2">
                        <motion.div
                          variants={diceVariants}
                          initial="initial"
                          animate="animate"
                        >
                          <Image
                            src={IconDice}
                            alt="IconBall"
                            width={20}
                            height={20}
                          />
                        </motion.div>
                      </div>
                      <Label htmlFor="casino" className="grow ml-2">
                        <span className="text-xs text-gray-600 block">
                          Casino
                        </span>
                        100 Giros Gratis!
                      </Label>
                      <RadioGroupItem
                        value="casino"
                        id="casino"
                        className="border-sivarbet-primary text-sivarbet-primary"
                      />
                    </div>

                    <div className="flex items-center justify-between p-4 rounded-lg border border-sivarbet-border bg-sivarbet-background h-[60px]">
                      <div className="flex items-center space-x-2">
                        <motion.div variants={footballVariants} initial="initial" animate="animate">
                          <Image src={IconBall} alt="IconBall" width={20} height={20} />
                        </motion.div>
                      </div>
                      <Label htmlFor="sports" className="grow ml-2">
                        <span className="text-xs text-gray-600 block">Deportivas</span>
                        Pronostico Gratis de 100!
                      </Label>
                      <RadioGroupItem value="sports" id="sports" className="border-sivarbet-primary text-sivarbet-primary" />
                    </div>

                    <div className="flex items-center justify-between p-4 rounded-lg border border-sivarbet-border bg-sivarbet-background h-[60px] mb-4">
                      <div className="flex items-center space-x-2">
                        <Image src={IconTrash} alt="IconTrash" width={20} height={20} />
                      </div>
                      <Label htmlFor="none" className="grow ml-2">No quiero un bono de bienvenida</Label>
                      <RadioGroupItem value="none" id="none" className="border-sivarbet-primary text-sivarbet-primary" />
                    </div>
                  </RadioGroup>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
          <MarketingRegisterMethods
            welcomeBonus={welcomeBonus || ''}
          />
        </div>
      </div>
    </div>
  );
};

export default WebWelcomeBonus;
